
        import {css} from 'lit-element';   
        export default css`:host{line-height:normal}:host sp-icon{width:20px;height:20px}`;
    